import { buildAxiosInstance, buildBasicAxiosInstance, buildMakeUseAxios } from "@root/api/api.tools";

export const axios = buildMakeUseAxios(`${import.meta.env.VITE_OFFER_SERVICE_URL}`);
export const axiosInstance = buildAxiosInstance(`${import.meta.env.VITE_OFFER_SERVICE_URL}`);
export const basicAxiosInstance = buildBasicAxiosInstance(`${import.meta.env.VITE_OFFER_SERVICE_URL}`);
